import React, { useEffect } from 'react';
import ContactForm from '../components/ContactForm';
import SEO from '../components/SEO';
import AppSidebar from '../components/common/AppSidebar';

const ContactPage = () => {
  const contactInfo = {
    address: '44 Newhall Street, Birmingham, B3 3PL',
    email: 'support@zahoot.ai',
    // phone: '+44 121 630 0000',
    phone: '+44 1216 303115',
    hours: 'Mondays to Fridays from 9am til 5pm'
  };

  // Set data-page attribute on body for CSS targeting
  useEffect(() => {
    document.body.setAttribute('data-page', 'home');
    
    return () => {
      document.body.removeAttribute('data-page');
    };
  }, []);

  return (
    <>
      <SEO 
        fallbackTitle="Contact Us - Zahoot"
        fallbackDescription="Get in touch with Zahoot. Contact us for questions about our legal services directory, support for your listing, or general inquiries."
      />
      <div className="home-page">
        {/* Sidebar Navigation */}
        <AppSidebar />
        
        <main className="home-page__main">
          <div className="max-w-6xl w-full px-4 lg:right-9 sm:px-6 lg:px-8 mx-auto z-10 relative">
            <div className="text-center mb-12 z-10 relative pt-8">
              <h1 className="text-5xl md:text-6xl font-bold mb-6 text-white">
                Contact <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#D80364] to-[#F0654B]">Us</span>
              </h1>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto">
                Get in touch with our team
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              <div className="bg-purple-900/50 rounded-xl p-8 shadow-lg h-full">
                <h2 className="text-2xl font-bold text-white mb-6">Send us a message</h2>
                <ContactForm />
              </div>
              
              <div className="space-y-6">
                <div className="bg-purple-900/50 rounded-xl p-6 shadow-lg">
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-12 bg-purple-500/30 rounded-full flex items-center justify-center mr-4">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-6 w-6 text-purple-300">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-white">Call Us</h3>
                      <p className="text-gray-300">{contactInfo.phone}</p>
                    </div>
                  </div>
                </div>
                
                <div className="bg-purple-900/50 rounded-xl p-6 shadow-lg">
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-12 bg-purple-500/30 rounded-full flex items-center justify-center mr-4">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-6 w-6 text-purple-300">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-white">Email Us</h3>
                      <p className="text-gray-300">{contactInfo.email}</p>
                    </div>
                  </div>
                </div>
                
                <div className="bg-purple-900/50 rounded-xl p-6 shadow-lg">
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-12 bg-purple-500/30 rounded-full flex items-center justify-center mr-4">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-6 w-6 text-purple-300">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-white">Our Address</h3>
                      <p className="text-gray-300">{contactInfo.address}</p>
                    </div>
                  </div>
                </div>
                
                <div className="bg-purple-900/50 rounded-xl p-6 shadow-lg">
                  <div className="flex items-center mb-4">
                    <div className="w-12 h-12 bg-purple-500/30 rounded-full flex items-center justify-center mr-4">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="h-6 w-6 text-purple-300">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-xl font-semibold text-white">Working Hours</h3>
                      <p className="text-gray-300">{contactInfo.hours}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default ContactPage; 